<template>
  <div class="selectProductStyle">
    <v-autocomplete
      v-model="inputValue"
      multiple
      item-text="label"
      item-value="value"
      :items="createProductSelectBoxValueFrom(productList)"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      clearable
      :height="height"
      :disabled="disabled"
      :filled="disabled"
      :menu-props="{ closeOnContentClick: false }"
      :no-data-text="$t('common.common_no-data')"
      @input="searchInput"
      :search-input.sync="searchInput"
    >
      <template v-slot:selection="{ index }">
        <div v-if="index === 0" class="selectedItem">
          {{ selectedList }}
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Array,
      require: false,
      default: () => []
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    disabled: { default: false }
  },
  data: () => ({
    searchInput: null,
    productList: []
  }),
  created() {
    this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapGetters('Product', ['getProductListFromState']),
    init() {
      this.getProductList()
    },
    async getProductList() {
      await this.getProductListFromApi({
        supplierName: this.searchInput
      })
      this.productList = this.getProductListFromState()
    },
    createProductSelectBoxValueFrom(productList) {
      if (productList) {
        return productList.map((ele) => {
          return {
            value: ele.productId,
            label: ele.nameJp
          }
        })
      }
      return []
    }
  },
  computed: {
    selectedList() {
      return this.inputValue.map((item) => item.label).join(',')
    },
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectProductStyle {
  width: 100%;
  &::v-deep {
    .v-select__selections {
      display: flex; // 追加
      flex-wrap: nowrap; // 追加
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .selectedItem {
      // flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // & + input {
      //   flex: 0;
      //   &:focus {
      //     flex: 1;
      //   }
      // }
    }
  }
}
</style>
